<div (click)="onCardClick()" class="image-container coupon-height" tapEffect
>
  <a (visibilityChange)="onVisibilityChanged($event)"
     [intersectionDebounce]="0"
     [style]="{ 'max-height': commonContainer?.image?.height}"
     appIntersectionObserver
     class="card-blk"
     href="{{ commonContainer?.navigationURL ? commonContainer?.navigationURL : commonContainer?.externalUrl }}"
     onclick="return false;"
  >
    @if (commonContainer?.isInitialLoading) {
      <img
        [ngSrc]="pImage$ | async"
        [alt]="commonContainer?.image?.alt"
        width="100"
        height="100"
        [priority]="true"
      />
    }
    @if (!commonContainer?.isInitialLoading) {
      <img
        [ngSrc]="pImage$ | async"
        [alt]="commonContainer?.image?.alt"
        width="100"
        height="100"
        [priority]="false"
        [loading]="'lazy'"
      />
    }
  </a>
</div>
